const _ = require('underscore/underscore-min');
const InView = require('in-view');
const Utils = require('core-helpers/utils.js');
const Tracking = require('tracking/tracking-controller.js');

(function(root, doc, undefined) {

    'use strict';

    // Private vars
    const stickyClass = 'sticky-nav__wrap--fixed';
    const activeLinkClass = 'sticky-nav__item--visible';
    const stickyScrollbarOuter = Utils.getById('sticky-navigation-outer');
    const stickyScrollbar = Utils.getById('sticky-navigation');
    const scrollSpyElements = Utils.getElementsByClass('js-scrollspy-item');
    let stickyPosFromTop = 0;
    let isNavFixed = false;
    let currentActiveLink = null;

    const getCurrentScrollPosition = () => {
        return root.scrollY || doc.documentElement.scrollTop;
    };

    const addFixedNavClass = () => {
        if (!isNavFixed) {
            Utils.addClass(stickyScrollbar, stickyClass);
            isNavFixed = true;
        }
    };

    const removeFixedNavClass = () => {
        if (isNavFixed) {
            Utils.removeClass(stickyScrollbar, stickyClass);
            isNavFixed = false;
        }
    };

    const addScrollSpyClass = (item) => {
        Utils.addClass(item, activeLinkClass);
    };

    const removeScrollSpyClass = (item) => {
        Utils.removeClass(item, activeLinkClass);
    };

    /**
     * Gets fired on every scroll event.
     * Here we detect if the sticky nav has reached the top of the viewport.
     */
    const handleStickyNav = () => {
        const currentScrollY = getCurrentScrollPosition();
        const navIsSticky = Boolean(currentScrollY >= stickyPosFromTop);

        if (navIsSticky) {
            addFixedNavClass();
        } else {
            removeFixedNavClass();
        }
    };

    /**
     * On init we save the exact distance that the sticky nav sits from the top of the page.
     * As the page might already have been scrolled, we need to add the current scroll position to this value.
     * @return {Number}
     */
    const getDistanceFromTop = (el) => {
        const elPosition = el.getBoundingClientRect().top;
        const currentScrollPosition = getCurrentScrollPosition();
        return Math.round(elPosition + currentScrollPosition);
    };

    const storeStickyNavTopPosition = () => {
        stickyPosFromTop = getDistanceFromTop(stickyScrollbarOuter);
    };

    /**
     * We loop through all the navigation links
     * If the href value matches our activeLink string,
     * we apply a class to the element.
     */
    const applyScrollSpyClasses = () => {
        const scrollSpyLinks = Utils.getElementsByClass('js-scrollspy-link', stickyScrollbar);
        _.each(scrollSpyLinks, function(item) {
            let itemLink = item.getAttribute('href').replace('#', '');

            if (itemLink === currentActiveLink) {
                addScrollSpyClass(item);
            } else {
                removeScrollSpyClass(item);
            }
        });
    };

    /**
     * Used for scrollspy
     * We find the first object in an array that is
     * visible in the viewport currently.
     */
    const getActiveSection = () => {
        return _.find(scrollSpyElements, function(item) {
            const isInView = InView.is(document.querySelector('#' + item.id));
            return isInView ? item : null;
        });
    };

    const sendSectionTracking = (activeSection) => {
        Tracking.send('PAYWALL_SECTION_VIEWED', {
            source_page: 'paywall',
            tab_viewed: activeSection.id
        });
    };

    /**
     * Scroll handler for scrollspy
     * We essentially check if an element is visible anywhere in the viewport.
     * From the list of visible elements, we always choose the first element
     * (as it's closest to the top) and find the matching link in the navigation
     * to highlight using a CSS class.
     */
    const handleScrollSpy = () => {
        if (!scrollSpyElements.length) {
            return false;
        }

        /**
         * If activeSection exists and does not match the current active link,
         * set the active link to the active ID and toggle nav classes accordingly.
         */
        const activeSection = getActiveSection();
        if (activeSection && activeSection.id !== currentActiveLink) {
            currentActiveLink = activeSection.id;
            applyScrollSpyClasses(currentActiveLink);
            sendSectionTracking(activeSection);
        }
    };

    /**
     * Attach scroll listener to window to handle sticky navigation
     * We throttle this as to not hinder our performance
     */
    const trackScroll = () => {
        root.addEventListener('scroll', _.throttle(handleStickyNav, 100));
        root.addEventListener('scroll', _.debounce(handleScrollSpy, 150));
    };

    /**
     * Attach resize listener to window to handle browser viewport resizes
     * We debounce this as we only need to calculate this value when resize has finished.
     */
    const trackResize = () => {
        root.addEventListener('resize', _.debounce(storeStickyNavTopPosition, 200));
    };

    /**
     * Launch all required functions and config for sticky nav
     * - Get state of sticky nav
     * - Config for Zenscroll
     *
     * NB: Because of the extremely low threshold (0) on our interception observer that
     * ensures that the first div always fades in on page load if ANY part of it is visible;
     * we end up breaking the SPYscroll when clicking on a nav link.
     * To fix this, we ensure that our SMOOTHscroll always lands us a few pixels higher than usual
     * to push the previous section out of view entirely.
     * Not an ideal solution, but if we look at deploying this page for all users, we could remove
     * Zenscroll library and just use CSS :target to add an offset/padding above each section when targeted.
     *
     */
    const initStickyNav = () => {
        isNavFixed = Boolean(Utils.hasClass(stickyScrollbar, stickyClass));

        storeStickyNavTopPosition();
        trackScroll();
        trackResize();
        handleStickyNav();
        handleScrollSpy();
    };

    const jumpToDefaultSection = (sectionID) => {
        if(!root.location.hash){
            root.location.hash = sectionID;
        }
    };

    const init = () => {
        if (!stickyScrollbarOuter || !stickyScrollbar) {
            return false;
        }

        jumpToDefaultSection('premium-plans');

        initStickyNav();
    };

    init();

})(window, document);
